var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 24.6686C28 26.51 26.508 28.002 24.6667 28.002H7.33333C5.49267 28.002 4 26.51 4 24.6686V7.33529C4 5.49395 5.49267 4.00195 7.33333 4.00195H24.6667C26.508 4.00195 28 5.49395 28 7.33529V24.6686Z",
    fill: "#F50057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1832 9.8823C12.8805 9.9523 12.6665 10.2216 12.6665 10.5323V19.335C12.6665 19.703 12.3678 20.0016 11.9998 20.0016H11.3332C9.8605 20.0016 8.6665 20.897 8.6665 22.0016C8.6665 23.1063 9.8605 24.0016 11.3332 24.0016C12.8058 24.0016 13.9998 23.1063 13.9998 22.0016V14.2243C13.9998 13.9136 14.2138 13.6443 14.5165 13.575L19.3872 12.451C19.7005 12.3783 19.9998 12.6163 19.9998 12.9376V17.335C19.9998 17.703 19.7012 18.0016 19.3332 18.0016H18.6665C17.1938 18.0016 15.9998 18.897 15.9998 20.0016C15.9998 21.1063 17.1938 22.0016 18.6665 22.0016C20.1392 22.0016 21.3332 21.1063 21.3332 20.0016V8.83963C21.3332 8.41096 20.9345 8.09363 20.5165 8.1903L13.1832 9.8823Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleMusic);
export default __webpack_public_path__ + "static/media/apple-music.28964f0f0e573607feb98387c5550d5f.svg";
export { ForwardRef as ReactComponent };